import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "py-4" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("提交")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("取消")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      ref: "formRef",
      rules: _ctx.rules,
      model: _ctx.ip,
      "label-width": "120px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          label: "名称",
          prop: "name"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.ip.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.ip.name) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onSubmit(_ctx.formRef)))
            }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, { onClick: _ctx.onCancel }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["rules", "model"])
  ]))
}